/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EMAProviderInput,
  EMAProviderInput$Outbound,
  EMAProviderInput$outboundSchema,
} from "./emaproviderinput.js";

export type SetEMAProvidersRequestBody = {
  /**
   * Providers in the order they are tried, at most 10; each at most once. An empty list restores the external default.
   */
  providers: Array<EMAProviderInput>;
  /**
   * Any remote_session_issuer in the caller's organization that names the vendor authorization server.
   */
  remoteSessionIssuerId: string;
};

/** @internal */
export type SetEMAProvidersRequestBody$Outbound = {
  providers: Array<EMAProviderInput$Outbound>;
  remote_session_issuer_id: string;
};

/** @internal */
export const SetEMAProvidersRequestBody$outboundSchema: z.ZodMiniType<
  SetEMAProvidersRequestBody$Outbound,
  SetEMAProvidersRequestBody
> = z.pipe(
  z.object({
    providers: z.array(EMAProviderInput$outboundSchema),
    remoteSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteSessionIssuerId: "remote_session_issuer_id",
    });
  }),
);

export function setEMAProvidersRequestBodyToJSON(
  setEMAProvidersRequestBody: SetEMAProvidersRequestBody,
): string {
  return JSON.stringify(
    SetEMAProvidersRequestBody$outboundSchema.parse(setEMAProvidersRequestBody),
  );
}
